import { SelectOptionProps } from '@acceso/design-system';

import { CHANNEL_MEDIA_TYPE_TO_ICON } from '@/features/broadcasters/constants/icons';
import { useChannelsByIds } from '@/features/broadcasters/hooks/useChannelsByIds';
import { ParamsWithPagination } from '@/types/api';

import { useProgramBroadcasts } from '../api/get-program-broadcasts';
import { TProgramBroadcastFilters } from '../types';

type UseProgramBroadcastOptionsParams = {
  params?: ParamsWithPagination<TProgramBroadcastFilters>;
};

export function useProgramBroadcastOptions({
  params,
}: UseProgramBroadcastOptionsParams = {}): SelectOptionProps<string>[] {
  const { data: { data: programBroadcasts = [] } = {} } = useProgramBroadcasts({
    params,
  });
  // The options do not wait for the channels; one not received yet only leaves
  // its icon out.
  const { channelsById } = useChannelsByIds(
    programBroadcasts.map(programBroadcast => programBroadcast.channel_id)
  );
  const options: SelectOptionProps<string>[] = programBroadcasts.map(programBroadcast => {
    const channel = channelsById.get(programBroadcast.channel_id);

    return {
      label: programBroadcast.name,
      value: programBroadcast.id,
      icon: channel ? CHANNEL_MEDIA_TYPE_TO_ICON[channel.media_type] : undefined,
    };
  });

  return options;
}
